import Tracker from "../prop-trackers/tracker.js";
import SinglePropTracker from "../prop-trackers/single-prop-tracker.js";

class Mux extends Tracker {
    constructor(userdata) {
        super();

        this._tracker = new SinglePropTracker(userdata);
        this._source = undefined;
        this._events = undefined;
        this._key = undefined;

        this._needsUpdateThis = () => this.protected_needsUpdate();
    }

    setSource(source, events) {
        if (source === this._source && events === this._events) return;

        this._source = source;
        this._events = events;
        this._updateTrackTarget();
    }

    setKey(key) {
        if (key === this._key) return;

        this._key = key;
        this._updateTrackTarget();
    }

    _updateTrackTarget() {
        if (this._key !== undefined) {
            this._tracker.listenNeedsUpdate(this._needsUpdateThis);
            this._tracker.track(this._source, this._events, this._key);
        } else {
            this._tracker.track();
            this._tracker.unlistenNeedsUpdate(this._needsUpdateThis);
        }
    }

    protected_startUpdate() {
        return this._tracker.startUpdate();
    }

    protected_finishUpdate() {
        this._tracker.finishUpdate();
    }
}

export default Mux;
